import { stevieTexts2 } from '../../uiParts/stevieTexts2-sidecar'
import { voyageCamera } from './voyageCamera-sidecar'
import { voyageGameStatus } from './voyageGameStatus-sidecar'
import { voyageLayers } from './voyageLayers-sidecar'
import type { IVoyageUiCanvas } from './voyageUiCanvas'
import { voyageUiCanvas } from './voyageUiCanvas-sidecar'

export interface IVoyageUiGame extends IVoyageUiCanvas {}

let _obj: IVoyageUiGame | null = null
export function get() {
  if (!_obj) {
    _obj = create()
    setOpen(false)
  }
  return _obj
}
const create = () => {
  let tw = 0
  let th = 0
  let canvas = voyageUiCanvas.create(tw, th, voyageLayers.getLayers().uiGame)
  canvas.autoOffset = false

  let obj: IVoyageUiCanvas = voyageUiCanvas.assign<IVoyageUiGame>(canvas, {})

  return obj
}

export const setOpen = (isOpen: boolean) => {
  let obj = get()
  voyageUiCanvas.setOpen(obj, isOpen)
}

export const render = () => {
  let obj = get()
  let g = obj.graphics

  voyageUiCanvas.clear(obj)

  let gb = voyageCamera.getGameBounds()

  let x = 20 //gb.width - 400
  let y = gb.height - 20

  let w = 200
  let h = 200
  let sy = y
  let sx = x

  let addText = (text: string, ox: number = 0, oy: number = 0) => {
    let t = voyageUiCanvas.addText(obj, text, x + ox, y + oy, 3)
    stevieTexts2.setWrapWidth(t, w - 60)
    y += 20
    return t
  }

  let addSpacer = () => {
    y += 30
  }

  let t = addText(voyageGameStatus.getSurvivalTime())
  stevieTexts2.setScale(t, 4)

  voyageUiCanvas.render(obj)
}

export const update = () => {
  let obj = get()
  if (obj.isOpen) {
    voyageUiCanvas.update(obj)
    render()
  }
}
